import React from 'react';
import { AutoConnectStatus } from 'interfaces/index';
import { ConsentDialogContainer } from './ConsentDialogContainer';
import { fetchActiveConnectionsCount } from 'actions/connections';
import { fetchAutoAccept } from 'actions/autoAccept';
import { fetchOrganizationDetails } from 'actions/organizationDetails';
import { fetchPaymentMethods } from 'actions/paymentMethods';
import { useAppDispatch, useTypedSelector } from '../../combineReducers';
import { useParams } from 'react-router-dom';

type RouteParams = {
  organizationId: string;
};

export const PaymentConsentContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<RouteParams>();
  const { organizationDetails } = useTypedSelector(state => state.organizationDetails);
  const { hasPaymentMethods, autoConnectStatus } = useTypedSelector(state => state.paymentMethods);

  const [showPaymentConsent, setShowPaymentConsent] = React.useState<boolean>(false);
  const handleHidePaymentConsent = () => setShowPaymentConsent(false);
  const renderPaymentConsent =
    hasPaymentMethods === false && autoConnectStatus === AutoConnectStatus.NoInitialSelection;

  React.useEffect(() => {
    organizationId && dispatch(fetchOrganizationDetails(organizationId));
  }, [dispatch, organizationId]);

  React.useEffect(() => {
    organizationDetails && dispatch(fetchPaymentMethods({ companyId: organizationDetails.companyId }));
  }, [dispatch, organizationDetails]);

  React.useEffect(() => {
    if (renderPaymentConsent) {
      setShowPaymentConsent(true);
    }
  }, [renderPaymentConsent]);

  React.useEffect(() => {
    if (renderPaymentConsent && organizationDetails) {
      dispatch(fetchActiveConnectionsCount(organizationDetails.aionOrganizationId));
    }
  }, [dispatch, organizationDetails, renderPaymentConsent]);

  React.useEffect(() => {
    if (renderPaymentConsent && organizationDetails) {
      dispatch(fetchAutoAccept(organizationDetails.aionOrganizationId));
    }
  }, [dispatch, organizationDetails, renderPaymentConsent]);

  return <ConsentDialogContainer open={showPaymentConsent} onClose={handleHidePaymentConsent} />;
};
